export default "__VITE_ASSET__DJEmpYPh__"